// extracted by mini-css-extract-plugin
module.exports = {"displayHeader":"display-header_displayHeader__dDvCo"};